import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconFolder24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.542 5a2 2 0 00-2 1.998V7L3.5 16.997V17c0 1.136.97 2 2.042 2h12.916c1.073 0 2.042-.864 2.042-2V9c0-1.136-.97-2-2.042-2h-6.4l-1.826-1.485C9.759 5.123 9.193 5 8.688 5H5.542zm-.5 2a.5.5 0 01.5-.5h3.146c.274 0 .462.066.587.17l.007.007 2.037 1.655.206.168h6.933c.309 0 .542.255.542.5v1H5.03l.012-2.997V7zm-.02 4.5L5 17v.001c0 .244.234.499.542.499h12.916c.309 0 .542-.255.542-.5v-5.5H5.023z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconFolder24);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;